import { useState } from "react";
import { Link } from "react-router-dom";
import { api, errMsg } from "../../lib/api";

export const AdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try { onLogin((await api.post("/auth/login", { email, password })).data); } catch (x) { setErr(errMsg(x)); } finally { setBusy(false); }
  };

  const field = "w-full rounded-xl border border-[var(--ink)]/15 bg-white/70 px-4 py-3.5 outline-none focus:border-[var(--gold)]";
  return (
    <div className="grid min-h-screen place-items-center px-5">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-sm space-y-4 rounded-[2rem] border border-[var(--gold)]/25 bg-white/50 p-8 backdrop-blur">
        <img src="/img/logo-aura-dark.png" alt="AURA Microblading & Nails" className="h-auto w-44" />
        <h1 className="font-display text-3xl">Area riservata</h1>
        <input data-testid="login-email-input" type="email" required placeholder="Email" className={field} value={email} onChange={(e) => setEmail(e.target.value)} />
        <input data-testid="login-password-input" type="password" required placeholder="Password" className={field} value={password} onChange={(e) => setPassword(e.target.value)} />
        {err && <p data-testid="login-error" className="text-sm text-red-700">{err}</p>}
        <button data-testid="login-submit-button" disabled={busy} className="w-full rounded-full bg-[var(--ink)] py-3.5 text-[var(--cream)] hover:bg-[var(--gold-deep)] disabled:opacity-60">{busy ? "Accesso..." : "Accedi"}</button>
        <Link to="/" className="block text-center text-sm text-[var(--ink-soft)] hover:text-[var(--ink)]">Torna al sito</Link>
      </form>
    </div>
  );
};
